import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ArrowLeft, Leaf } from 'lucide-react';
import { LOGO_URL } from '../mock';
import Footer from '../components/Footer';
import SEO from '../seo/SEO';

export default function LegalPage({ title, updated, sections }) {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [title]);

  return (
    <div className="font-body bg-[#F6F2E8] min-h-screen flex flex-col">
      <SEO
        title={title}
        description={`${title} for Wholesome 360 — Mediterranean healthy catering in Chicago. ${updated}.`}
        path={location.pathname}
        noindex={false}
      />
      <header className="border-b border-[#D6CFB8] bg-[#F6F2E8]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2.5">
            <img src={LOGO_URL} alt="Wholesome 360 logo" className="h-10 w-auto" />
          </Link>
          <Link to="/" className="inline-flex items-center gap-1.5 text-sm font-semibold text-[#245A40] hover:text-[#1B4631]">
            <ArrowLeft className="w-4 h-4" /> Back home
          </Link>
        </div>
      </header>

      <main className="flex-1 max-w-4xl mx-auto w-full px-4 sm:px-6 py-14 sm:py-20">
        <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-[#E6EBD5] text-[#1B4631] text-xs font-semibold border border-[#CFDAB1]">
          <Leaf className="w-3.5 h-3.5" /> Legal
        </div>
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl text-[#1B2A22] mt-4 leading-[1.05]">
          {title}
        </h1>
        <div className="mt-3 text-sm text-[#6F6A55]">{updated}</div>

        <div className="mt-10 space-y-10">
          {sections.map((s) => (
            <section key={s.heading}>
              <h2 className="font-display text-2xl sm:text-3xl text-[#1B2A22]">{s.heading}</h2>
              <div className="mt-4 space-y-4 text-[#3F4A42] text-[16px] sm:text-[17px] leading-[1.75]">
                {s.body.map((p, i) => (
                  <p key={i}>{p}</p>
                ))}
              </div>
            </section>
          ))}
        </div>
      </main>

      <Footer />
    </div>
  );
}
